module.exports = __webpack_public_path__ + "static/media/arrow-button.2179af22.svg";